import Hero from "@/components/sections/Hero";
import LogoStrip from "@/components/sections/LogoStrip";
import Categories from "@/components/sections/Categories";
import About from "@/components/sections/About";
import StoreInfo from "@/components/sections/StoreInfo";
import CtaBanner from "@/components/sections/CtaBanner";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <LogoStrip />
            <Categories />
            <About />
            <StoreInfo />
            <CtaBanner />
        </div>
    );
}
